module.exports = __webpack_public_path__ + "static/media/feedback_card_edit_btn.10c87711.svg";